import { render, staticRenderFns } from "./NoteVersionCardContent.vue?vue&type=template&id=8865a30c&"
import script from "./NoteVersionCardContent.vue?vue&type=script&lang=ts&"
export * from "./NoteVersionCardContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports